import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as Api } from '../../assets/icons/api.svg';
import { ReactComponent as Cards } from '../../assets/icons/cards.svg';
import { ReactComponent as Collections } from '../../assets/icons/collections.svg';
import { ReactComponent as Dashboard } from '../../assets/icons/dashboard.svg';
import { ReactComponent as Disputes } from '../../assets/icons/disputes.svg';
import { ReactComponent as FeatureFlags } from '../../assets/icons/feature-flags.svg';
import { ReactComponent as KYC } from '../../assets/icons/kyc.svg';
import { ReactComponent as Onboarding } from '../../assets/icons/onboarding.svg';
import { ReactComponent as PaymentLinks } from '../../assets/icons/payment-links.svg';
import { ReactComponent as Payout } from '../../assets/icons/payout.svg';
import { ReactComponent as Settings } from '../../assets/icons/settings.svg';
import { ReactComponent as Settlement } from '../../assets/icons/settlement.svg';
import { ReactComponent as Transactions } from '../../assets/icons/transactions.svg';
import { ReactComponent as Wallets } from '../../assets/icons/wallets.svg';

const Icon = ({ name, ...props }) => {
  const IconComponent = icons[name] ?? 'span';

  return <IconComponent {...props} />;
};

const icons = {
  Cards: Cards,
  Collections: Collections,
  Conversions: Settlement,
  Dashboard: Dashboard,
  Developers: Api,
  Settlement: Settlement,
  Transactions: Transactions,
  Wallets: Wallets,
  Settings: Settings,
  'Payment Links': PaymentLinks,
  Disputes: Disputes,
  Payout: Payout,
  Fees: PaymentLinks,
  'Feature Flags': FeatureFlags,
  KYC: KYC,
  Onboarding: Onboarding
};

Icon.propTypes = {
  name: PropTypes.string
};

export { Icon };
